import { render, staticRenderFns } from "./SummarComplaints.vue?vue&type=template&id=7bdba94c&scoped=true&"
import script from "./SummarComplaints.vue?vue&type=script&lang=js&"
export * from "./SummarComplaints.vue?vue&type=script&lang=js&"
import style0 from "./SummarComplaints.vue?vue&type=style&index=0&id=7bdba94c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdba94c",
  null
  
)

export default component.exports